export enum UserRole {
    ADMIN = "admin",
    USER = "user",
}
